import { render, staticRenderFns } from "./SimulationExclusionsProduct.vue?vue&type=template&id=e0c273d6&scoped=true&"
import script from "./SimulationExclusionsProduct.vue?vue&type=script&lang=js&"
export * from "./SimulationExclusionsProduct.vue?vue&type=script&lang=js&"
import style0 from "./SimulationExclusionsProduct.vue?vue&type=style&index=0&id=e0c273d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c273d6",
  null
  
)

export default component.exports